module.exports = __webpack_public_path__ + "media/images/recruitment/landing/img_phone-number-ac08e78a6b01bbcb1719d6e007944e3e.svg";